import { render } from "./InvestmentsSidebar.vue?vue&type=template&id=28c5f1ec&scoped=true"
import script from "./InvestmentsSidebar.vue?vue&type=script&lang=js"
export * from "./InvestmentsSidebar.vue?vue&type=script&lang=js"

import "./InvestmentsSidebar.vue?vue&type=style&index=0&id=28c5f1ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c5f1ec"]])

export default __exports__